import cn from 'classnames';

import s from './Plus.module.scss';

const Plus = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={cn(s.root, className)}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect
        x="24"
        y="40.001"
        width="8"
        height="40"
        transform="rotate(-180 24 40.001)"
        fill="currentColor"
      />
      <rect
        x="40"
        y="16.001"
        width="8"
        height="40"
        transform="rotate(90 40 16.001)"
        fill="currentColor"
      />
    </svg>
  );
};

export { Plus };
